export const initialState = () => ({
  filters: {
    startDate: "",
    endDate: "",
    exportationTypes: []
  }
})
